import { ErrorHandler, Injectable, inject } from '@angular/core';
import { GapiLoaderService } from './gapi-loader.service';
import { RejectOnTimeoutService } from './reject-on-timeout.service';

@Injectable({
  providedIn: 'root',
})
export class GapiClientLoaderGeneratorService {
  private errorHandler = inject(ErrorHandler);
  private gapiLoaderService = inject(GapiLoaderService);
  private rejectOnTimeoutService = inject(RejectOnTimeoutService);

  generate(libName: string, libVer: string, baseUrl?: string) {
    return () => {
      return this.gapiLoaderService.load().then((gApi) => {
        if (gApi.client[libName]) {
          return gApi.client[libName];
        }

        return this.rejectOnTimeoutService
          .withTimeout(
            gApi.client.load(libName, libVer, null, baseUrl).then(() => {
              if (gApi.client[libName]) {
                console.debug(`${libName}.${libVer} Loaded`);

                return gApi.client[libName];
              }

              return Promise.reject();
            }),
            `${libName}.${libVer}`,
          )
          .catch((err) => {
            const errMsg = `${libName}.${libVer} Load Failed`;

            this.errorHandler.handleError(err || errMsg);

            return Promise.reject(err || errMsg);
          });
      });
    };
  }
}
